import * as React from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { RootState } from "../../state";
import { featuredPostsSelector, pinnablePostsSelector } from "../selectors";
import { loadPinnablePostsWorker, draftPostPinUpdated } from "../actions";
import ModalContainer, { ModalRenderFunc } from "../../common/components/modal/ModalContainer";
import FeaturedPostsSection from "./FeaturedPostsSection";
import PostSelectContainer from "../../posts/components/PostSelectContainer";

interface OwnProps {
  showAllPostsLink?: boolean;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

interface State {
  editingPinIndex: number | null;
}

class FeaturedPostsSectionContainer extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      editingPinIndex: null,
    };
  }

  public onClickToOpen = (index: number, onOpen: () => void) => {
    this.setState({ editingPinIndex: index });
    const { company, isPinnablePostsLoaded, isPinnablePostsLoading, loadPinnablePostsWorker } = this.props;
    if (!isPinnablePostsLoaded && !isPinnablePostsLoading) {
      loadPinnablePostsWorker({ companyId: company.id });
    }
    onOpen();
  };

  public onCompleteSelectPost = (postId: number | null, onClose: () => void) => {
    const { draftPostPinUpdated } = this.props;
    const { editingPinIndex } = this.state;
    draftPostPinUpdated({
      postId,
      categoryCd: editingPinIndex!,
    });
    onClose();
  };

  public onCancelSelectPost = (onClose: () => void) => {
    this.setState({ editingPinIndex: null });
    onClose();
  };

  public render() {
    const { company, posts, draftPostPins, showAllPostsLink, editMode, locale } = this.props;
    return (
      <ModalContainer name="posts/selector" render={this.renderModal}>
        {({ onOpen }) => {
          return (
            <FeaturedPostsSection
              company={company}
              posts={posts}
              draftPostPins={draftPostPins}
              locale={locale}
              editable={editMode}
              onEdit={(index: number) => this.onClickToOpen(index, onOpen)}
              showAllPostsLink={showAllPostsLink}
            />
          );
        }}
      </ModalContainer>
    );
  }

  private renderModal: ModalRenderFunc = ({ onClose }) => {
    if (!this.props.isPinnablePostsLoaded) {
      return null;
    }

    const { pinnablePosts, locale, draftPostPins } = this.props;
    const { editingPinIndex } = this.state;
    const currentPin = draftPostPins.find(p => p.category_cd === editingPinIndex);
    const currentValue = currentPin && currentPin.post ? currentPin.post : null;
    return (
      <PostSelectContainer
        options={pinnablePosts}
        value={currentValue}
        newPostLink="/manage_posts/articles/new"
        isLoading={false}
        locale={locale}
        onComplete={(postId: number | null) => this.onCompleteSelectPost(postId, onClose)}
        onCancel={() => this.onCancelSelectPost(onClose)}
      />
    );
  };
}

function mapStateToProps(state: RootState) {
  const posts = featuredPostsSelector(state);
  const pinnablePosts = pinnablePostsSelector(state);
  const { isPinnablePostsLoaded, isPinnablePostsLoading, draftPostPins } = state.companies.posts;
  return {
    company: state.companies.common.draftCompany!,
    editMode: state.companies.common.editMode,
    locale: state.auth.locale,
    posts,
    pinnablePosts,
    isPinnablePostsLoaded,
    isPinnablePostsLoading,
    draftPostPins,
  };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>) {
  return bindActionCreators(
    {
      loadPinnablePostsWorker,
      draftPostPinUpdated,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedPostsSectionContainer);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/FeaturedPostsSectionContainer.tsx